import { memo, useEffect } from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormSelectField from 'components/ui/form/FormSelectField';

import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  object_id: yup.number().required('settings.contracts.validation.objectId'),
  user_id: yup.number().required('change.tab.contract.validation.staffId'),
});

const TargetAddEditModal = (props) => {
  const { open, setOpen, setRefetch, selected, setSelected } = props;
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      object_id: '',
      user_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (selected?.id) {
        submit(
          { type: 'postUpdate', contentType: 'simple' },
          values,
          '/admin/user-object',
          t('common.table.staff'),
          selected?.id,
          false,
          handleFinishRequest
        );
      } else
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          '/admin/user-object',
          t('common.table.staff'),
          null,
          false,
          handleFinishRequest
        );
    },
  });

  useEffect(() => {
    if (selected) {
      formik.setValues({
        object_id: selected.object_id,
        user_id: selected.user_id,
      });
    }
  }, [selected]);

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setSelected({});
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      disableEscapeKeyDown={true}
      PaperProps={{ className: '!base-border !shadow-none' }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-gray-100 !text-center !mb-2 !min-w-[500px]'
      >
        {selected?.id ? (
          <span>{t('settings.accessUser.editModal.title')}</span>
        ) : (
          <span>{t('settings.accessUser.addModal.title')}</span>
        )}
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSelectField
                delay={0}
                duration={0}
                fieldName='object_id'
                label={t('common.fields.objectName')}
                formik={formik}
                path={'/admin/object/index'}
                isitemsizesmall={true}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSelectField
                delay={0}
                duration={0}
                fieldName='user_id'
                label={t('common.fields.staff')}
                formik={formik}
                path={'/dictionary/staffes'}
                isitemsizesmall={true}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.6}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(TargetAddEditModal);
